import { useInstanceSettings } from '../lib/accountHooks.js'
import { DEFAULT_BANNER_TEXT, type InstanceBannerValue } from '../sites/banner.js'

const TONE_STYLE = {
  training: { background: 'var(--color-accent-2-800)', color: 'var(--color-accent-2-100)' },
  staging: { background: 'var(--color-accent-800)', color: 'var(--color-accent-100)' },
} as const

/**
 * Settings → Instance → Banner: a coloured bar across the top of every admin
 * screen, so nobody mistakes a training or staging instance for the real
 * one. Off (tone null) by default; not dismissable.
 */
export function InstanceBanner() {
  const settings = useInstanceSettings()
  const banner = (settings.data?.instance as { banner?: InstanceBannerValue } | undefined)?.banner
  if (!banner?.tone) return null

  return (
    <div
      role="region"
      aria-label="Instance banner"
      data-tone={banner.tone}
      style={{
        flex: 'none',
        padding: '6px var(--space-6)',
        fontSize: 12.5,
        fontWeight: 500,
        letterSpacing: '0.01em',
        textAlign: 'center',
        ...TONE_STYLE[banner.tone],
      }}
    >
      {banner.text.trim() || DEFAULT_BANNER_TEXT[banner.tone]}
    </div>
  )
}
